import PropTypes from 'prop-types';
import React from 'react';
import { showToast } from 'stores/ToastStore';
import SessionStore from 'stores/SessionStore';
import AccountingWebAPIUtils, { setPayoutPaymentMethod, } from 'utils/AccountingWebAPIUtils';
import { getShipmentByOid, getShipmentsLedgers, } from 'utils/ShipmentWebAPIUtils';
import { getOrder } from 'utils/OrderWebAPIUtils';
import { isLegManagementEnabled } from 'helpers/legs-helper';
import AccountingActionCreators from 'actions/AccountingActionCreators';
import CustomersAPI from 'utils/CustomersAPIUtils';
import PayoutStore from 'stores/accounting/PayoutStore';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import PayoutJobList from './v2/PayoutJobList';
import PayoutHeader from './v2/PayoutHeader';
import ShipmentSearch from 'components/site/shipment-search';
import { withTranslation } from 'react-i18next';
import { BadgeAlt as Badge, Button, Card, CardHeader, CardContent, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Tabs, TabsList, TabsTrigger, TabsContent, } from '@cargomatic/ui';
import { CheckCircle, ChevronDown, DollarSign, Download, ExternalLink, Mail, RefreshCw, XCircle, } from 'lucide-react';
import moment from 'moment';
import { titleize } from 'underscore.string';
import formatMoney from 'utils/formatters/Money';
import { unescapeSpecialChars } from 'helpers/helper_functions';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import { sluggify } from '../../../../utils/localization/utils';
import { getPayoutStatusColor } from './colors';
import PaymentSummary from '../payment-summary';
import PaymentHistory from '../payment-history';
import LogPaymentModal from '../log-payment-modal';
import PaymentMethodDialog from '../PaymentMethodDialog';
import SendEmailModal from '../send-email-modal';
import { fetchSignedUrlByForeignKey } from '../../../../utils/DocumentsAPIUtils';
import { paymentMethods, paymentStatus, } from '../../../../constants/accounting';
import HistoryTable from '../history-table';
const setPayoutIdOnPayoutLineItems = (payoutLineItemGroups, payoutId) => {
    return (payoutLineItemGroups !== null && payoutLineItemGroups !== void 0 ? payoutLineItemGroups : []).map((payoutLineItemGroup) => {
        var _a;
        return (Object.assign(Object.assign({}, payoutLineItemGroup), { lineItems: ((_a = payoutLineItemGroup.lineItems) !== null && _a !== void 0 ? _a : []).map((lineItem) => (Object.assign(Object.assign({}, lineItem), { payout_id: payoutId }))) }));
    });
};
const getStateFromStores = (id) => {
    let payout = PayoutStore.getPayout(id);
    let balance = 0;
    if (payout) {
        balance = payout.amount_due;
        if (payout.lineItemGroups) {
            payout = Object.assign(Object.assign({}, payout), { lineItemGroups: setPayoutIdOnPayoutLineItems(payout.lineItemGroups, payout._id) });
        }
    }
    return {
        payout: payout,
        balance: balance,
        loading: false,
    };
};
const STRIPE = 'automated';
const ACH = 'manual';
const JOBLIST_ACTIONS = {
    ADD: 'add',
    REMOVE: 'remove',
};
class PayoutDetails extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = async () => {
            var _a, _b;
            const payoutState = getStateFromStores(this.getPayoutId());
            if (payoutState.payout &&
                ((_a = payoutState.payout.jobs) === null || _a === void 0 ? void 0 : _a.length) &&
                !this.state.order) {
                try {
                    const shipment = await getShipmentByOid(payoutState.payout.jobs[0]);
                    const orderId = ((_b = shipment === null || shipment === void 0 ? void 0 : shipment.order) === null || _b === void 0 ? void 0 : _b._id) || (shipment === null || shipment === void 0 ? void 0 : shipment.order);
                    if (orderId) {
                        const { entity } = await getOrder(orderId);
                        this.setState(Object.assign(Object.assign({}, payoutState), { order: entity === null || entity === void 0 ? void 0 : entity.order }));
                        return;
                    }
                }
                catch (e) {
                    console.error('Error fetching order for payout:', e);
                }
            }
            this.setState(payoutState);
        };
        this.handlePayoutUpdated = (updatedPayout) => {
            this.setState({ payout: updatedPayout });
        };
        this.sendEmail = (emails) => {
            var _a;
            AccountingActionCreators.emailPayout((_a = this.state.payout) === null || _a === void 0 ? void 0 : _a._id, emails);
        };
        this.handleDownload = async () => {
            var _a;
            const { t } = this.props;
            const newWindow = window.open('', '_blank');
            try {
                const { url, error } = await fetchSignedUrlByForeignKey((_a = this.state.payout) === null || _a === void 0 ? void 0 : _a._id);
                if (url) {
                    if (newWindow) {
                        newWindow.opener = null;
                        newWindow.location.href = url;
                    }
                }
                else {
                    newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                    showToast(t('GET_SIGNED_URL_ERROR'), error, 'error');
                }
            }
            catch (e) {
                newWindow === null || newWindow === void 0 ? void 0 : newWindow.close();
                showToast(t('GET_SIGNED_URL_ERROR'), e === null || e === void 0 ? void 0 : e.message, 'error');
            }
        };
        this.reprocessCarrierPayout = async () => {
            var _a, _b;
            const { t } = this.props;
            this.setState({ isReprocessing: true });
            try {
                const response = await AccountingWebAPIUtils.reprocessCarrierPayout((_a = this.state.payout) === null || _a === void 0 ? void 0 : _a._id);
                if (response && response.payout) {
                    const updatedPayout = Object.assign(Object.assign({}, response.payout), { jobs: ((_b = response.payout.jobs) !== null && _b !== void 0 ? _b : []).map(({ _id }) => _id) });
                    this.handlePayoutUpdated(updatedPayout);
                    showToast(t('REPROCESS_SUCCESS'), t('SUCCESSFULLY_REPROCESSED_PAYOUT'), 'success');
                }
            }
            catch (entity) {
                const err = entity === null || entity === void 0 ? void 0 : entity.error;
                if (err) {
                    showToast(t('REPROCESS_ERROR'), t('ERROR_REPROCESSING_WITH_VALUE', { error: err }), 'error');
                }
            }
            this.setState({ isReprocessing: false });
        };
        this.handleApprovalConfirm = () => {
            const { payout } = this.state;
            this.setState({ showApprovalModal: false }, () => {
                if ((payout === null || payout === void 0 ? void 0 : payout.status) === 'approved_internally') {
                    AccountingActionCreators.reversePayoutApproval(payout._id);
                }
                else {
                    AccountingActionCreators.approvePayout(payout._id);
                }
            });
        };
        this.handleVoidConfirm = () => {
            const { payout } = this.state;
            this.setState({ showVoidModal: false }, () => {
                if ((payout === null || payout === void 0 ? void 0 : payout.status) === 'void') {
                    AccountingActionCreators.reversePayoutVoid(payout._id);
                }
                else {
                    AccountingActionCreators.voidPayout(payout._id);
                }
            });
        };
        this.savePayment = (payment) => {
            var _a;
            AccountingActionCreators.recordPaymentForPayout((_a = this.state.payout) === null || _a === void 0 ? void 0 : _a._id, payment);
        };
        this.handlePaymentMethodSelect = async (value) => {
            var _a, _b;
            if (!value) {
                return;
            }
            const method = value.toLowerCase();
            const currentMethod = this.state.paymentMethod || ((_a = this.state.payout) === null || _a === void 0 ? void 0 : _a.payment_method);
            if (method && method !== currentMethod) {
                const previousMethod = currentMethod || null;
                const method_value = method === 'manual' ? ACH : STRIPE;
                try {
                    await setPayoutPaymentMethod(method_value, (_b = this.state.payout) === null || _b === void 0 ? void 0 : _b._id);
                    this.setState({ paymentMethod: method });
                    showToast('Payment method updated', null, 'success');
                }
                catch (e) {
                    console.error(e);
                    this.setState({ paymentMethod: previousMethod });
                    showToast('Failed to update payment method', null, 'error');
                }
            }
        };
        this.handleSavePaymentMethod = async () => {
            const { tempPaymentMethod } = this.state;
            if (tempPaymentMethod) {
                this.setState({ isSavingPaymentMethod: true });
                try {
                    await this.handlePaymentMethodSelect(tempPaymentMethod);
                    this.setState({ showPaymentMethodDialog: false });
                }
                finally {
                    this.setState({ isSavingPaymentMethod: false });
                }
            }
            else {
                this.setState({ showPaymentMethodDialog: false });
            }
        };
        this.setChanges = (updates) => {
            const { editMode } = this.state;
            this.setState({ updates });
            if (!editMode) {
                this.setState({ editMode: true });
            }
        };
        this.handleEditButton = async () => {
            var _a;
            const { t } = this.props;
            const { editMode, payout, updates } = this.state;
            if (!editMode) {
                return this.setState({ editMode: true });
            }
            if (!updates.changes || !updates.changes.length) {
                return this.setState({ editMode: false });
            }
            if (updates.changes && updates.changes.length) {
                try {
                    const updatedPayout = await AccountingWebAPIUtils.updatePayoutLineItems(payout._id, payout.version, updates.changes);
                    this.setState({
                        editMode: false,
                        payout: updatedPayout,
                        updates: [],
                    });
                }
                catch (e) {
                    showToast(t('UPDATE_LINE_ITEMS_ERROR'), ((_a = e === null || e === void 0 ? void 0 : e.entity) === null || _a === void 0 ? void 0 : _a.error) || (e === null || e === void 0 ? void 0 : e.message), 'error');
                }
            }
        };
        this.handleJobSelect = async (payout, job) => {
            var _a, _b, _c;
            const { t } = this.props;
            if (((_a = payout.jobs) !== null && _a !== void 0 ? _a : []).includes(job._id)) {
                return;
            }
            if (payout.status === 'paid' || payout.status === 'payment_initialized') {
                return;
            }
            this.setState({ showLineItemConfirmModal: false });
            try {
                const updatedJobIds = [...((_b = payout.jobs) !== null && _b !== void 0 ? _b : []), job._id];
                const newPayout = await AccountingWebAPIUtils.updatePayoutJobs(payout, updatedJobIds, JOBLIST_ACTIONS.ADD);
                this.setState({ payout: newPayout });
            }
            catch (e) {
                showToast(t('JOB_ADD_ERROR'), ((_c = e === null || e === void 0 ? void 0 : e.entity) === null || _c === void 0 ? void 0 : _c.error) || (e === null || e === void 0 ? void 0 : e.message), 'error');
            }
        };
        this.handleJobRemove = async (payout, lineItem) => {
            var _a, _b;
            const { t } = this.props;
            try {
                const updatedJobIds = ((_a = payout.jobs) !== null && _a !== void 0 ? _a : []).filter((id) => id !== lineItem.shipment_id);
                this.setState({ showLineItemConfirmModal: false });
                const newPayout = await AccountingWebAPIUtils.updatePayoutJobs(payout, updatedJobIds, JOBLIST_ACTIONS.REMOVE);
                showToast(t('JOB_REMOVE_SUCCESS'), t('SUCCESSFULLY_REMOVED_JOB'), 'success');
                this.setState({
                    payout: newPayout,
                    confirmModal: this.confirmModalDefault(),
                });
            }
            catch (e) {
                showToast(t('JOB_REMOVE_ERROR'), ((_b = e === null || e === void 0 ? void 0 : e.entity) === null || _b === void 0 ? void 0 : _b.error) || (e === null || e === void 0 ? void 0 : e.message), 'error');
            }
        };
        this.handleSearch = async (payout, value, job) => {
            var _a, _b;
            const originalGroups = (_b = (_a = this.state.originalLineItemGroups) !== null && _a !== void 0 ? _a : payout.lineItemGroups) !== null && _b !== void 0 ? _b : [];
            const searchedShipmentId = job.shipmentId;
            const listOfJobs = originalGroups.filter((jobsAssociated) => jobsAssociated.shipmentId === searchedShipmentId);
            if (listOfJobs.length) {
                this.setState({
                    selectedValue: value,
                    originalLineItemGroups: originalGroups,
                    payout: Object.assign(Object.assign({}, payout), { lineItemGroups: listOfJobs }),
                });
            }
            else {
                this.setState({ selectedValue: value });
            }
        };
        this.onSelectChange = (value) => {
            var _a, _b;
            const payoutState = getStateFromStores(this.getPayoutId());
            const { selectedValue, originalLineItemGroups } = this.state;
            const lineItemGroups = (_b = originalLineItemGroups !== null && originalLineItemGroups !== void 0 ? originalLineItemGroups : (_a = payoutState.payout) === null || _a === void 0 ? void 0 : _a.lineItemGroups) !== null && _b !== void 0 ? _b : [];
            value = value.trim().toUpperCase();
            if (value.length && value !== selectedValue) {
                const filteredJobs = lineItemGroups.filter((lineItemGroup) => { var _a; return (_a = lineItemGroup.shipmentId) === null || _a === void 0 ? void 0 : _a.includes(value); });
                this.setState({
                    payout: Object.assign(Object.assign({}, payoutState.payout), { lineItemGroups: filteredJobs }),
                });
            }
            else {
                this.setState(Object.assign(Object.assign({}, payoutState), { originalLineItemGroups: null }));
            }
        };
        this.confirmModalDefault = () => {
            return {
                title: '',
                message: '',
                onConfirm: null,
            };
        };
        this.confirmAddShipment = async (job) => {
            var _a, _b;
            try {
                const { t } = this.props;
                const ledgersResult = await getShipmentsLedgers([job._id], 'payout');
                const jobLineItems = ledgersResult && ledgersResult.items && ledgersResult.items.length
                    ? ledgersResult.items[0]
                    : {};
                const hasOtherPaidItems = (jobLineItems.payables || []).some((lineItem) => {
                    var _a, _b, _c, _d;
                    if (!lineItem.payout_id) {
                        return false;
                    }
                    return (lineItem.payout &&
                        lineItem.payout.status !== 'paid' &&
                        ((_b = (_a = lineItem.payout) === null || _a === void 0 ? void 0 : _a._id) === null || _b === void 0 ? void 0 : _b.toString()) !==
                            ((_d = (_c = this.state.payout) === null || _c === void 0 ? void 0 : _c._id) === null || _d === void 0 ? void 0 : _d.toString()));
                });
                const hasPaidLineItemsEligibleToMove = ((_a = jobLineItems.payables) !== null && _a !== void 0 ? _a : []).some((lineItem) => {
                    if (!lineItem.invoice_id) {
                        return true;
                    }
                    return lineItem.payout && lineItem.payout.status !== 'paid';
                });
                const hasUnpaidLineItems = ((_b = job.payables) !== null && _b !== void 0 ? _b : []).some((payable) => !payable.payout_id);
                if (!hasPaidLineItemsEligibleToMove && !hasUnpaidLineItems) {
                    const title = t('UNABLE_TO_ADD_SHIPMENT_TO_PAYOUT_TITLE', {
                        shipmentId: job.shipment_id,
                    });
                    const message = t('UNABLE_TO_ADD_SHIPMENT_TO_PAYOUT_MESSAGE');
                    this.setState({
                        showLineItemConfirmModal: true,
                        confirmModal: {
                            title,
                            message,
                            onConfirm: () => this.setState({
                                showLineItemConfirmModal: false,
                                confirmModal: this.confirmModalDefault(),
                            }),
                        },
                    });
                }
                else if (hasOtherPaidItems || hasUnpaidLineItems) {
                    const title = t('ADD_SHIPMENT_TO_PAYOUT_TITLE', {
                        shipmentId: job.shipment_id,
                    });
                    const message = t('ADD_SHIPMENT_TO_PAYOUT_MESSAGE');
                    this.setState({
                        showLineItemConfirmModal: true,
                        confirmModal: {
                            title,
                            message,
                            onConfirm: () => this.handleJobSelect(this.state.payout, job),
                        },
                    });
                }
                else {
                    this.handleJobSelect(this.state.payout, job);
                }
            }
            catch (error) {
                console.error(error);
            }
        };
        this.confirmRemoveShipment = (job) => {
            const { t } = this.props;
            const title = t('REMOVE_SHIPMENT_TO_PAYOUT_TITLE', {
                shipmentId: job.shipmentId,
            });
            const message = t('REMOVE_SHIPMENT_TO_PAYOUT_MESSAGE');
            this.setState({
                showLineItemConfirmModal: true,
                confirmModal: {
                    title,
                    message,
                    onConfirm: () => this.handleJobRemove(this.state.payout, job),
                },
            });
        };
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            loading: true,
            selectedValue: '',
            paymentMethod: null,
            isAdmin: SessionStore.isAdmin(),
            editMode: false,
            updates: [],
            showLineItemConfirmModal: false,
            showPaymentMethodDialog: false,
            tempPaymentMethod: null,
            isSavingPaymentMethod: false,
            activeTab: 'jobs',
            showLogPaymentModal: false,
            confirmModal: this.confirmModalDefault(),
            isFinanceAdmin: SessionStore.isFinanceAdmin(),
            hasFinanceAdminRole: SessionStore.hasFinanceAdminRole(),
            showSendEmailModal: false,
            isReprocessing: false,
            showApprovalModal: false,
            showVoidModal: false,
        };
    }
    componentDidMount() {
        PayoutStore.register(this.onChange);
        AccountingActionCreators.getPayout(this.getPayoutId());
    }
    componentWillUnmount() {
        PayoutStore.unregister(this.onChange);
    }
    componentDidUpdate(_prevProps, prevState) {
        if (!prevState.payout && this.state.payout) {
            this.populateFundingData(this.state.payout);
        }
    }
    populateFundingData(payoutArg) {
        var _a;
        const carrierId = (_a = payoutArg === null || payoutArg === void 0 ? void 0 : payoutArg.carrier) === null || _a === void 0 ? void 0 : _a._id;
        if (!carrierId)
            return;
        CustomersAPI.getBankAccounts(carrierId)
            .then((res) => {
            this.setState((prevState) => {
                var _a;
                const response = (_a = res === null || res === void 0 ? void 0 : res.entity) === null || _a === void 0 ? void 0 : _a.data;
                return {
                    payout: Object.assign(Object.assign({}, prevState.payout), { carrier: Object.assign(Object.assign({}, prevState.payout.carrier), { bank_accounts: response === null || response === void 0 ? void 0 : response.external_accounts }) }),
                };
            });
        })
            .catch((err) => {
            console.error(err.stack || err);
        });
    }
    getPayoutId() {
        var _a, _b;
        return this.props.payoutId || ((_b = (_a = this.props.match) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id);
    }
    defineDropdownSelectedValue() {
        const { paymentMethod, payout } = this.state;
        const payment_method = payout === null || payout === void 0 ? void 0 : payout.payment_method;
        if (paymentMethod) {
            return paymentMethod === 'automated' ? STRIPE : ACH;
        }
        if (payment_method) {
            return payment_method === 'automated' ? STRIPE : ACH;
        }
        return '';
    }
    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return (React.createElement("p", { "data-testid": "p-8d6c1304", className: "px-4 py-5 sm:p-6" }, t('LOADING')));
        }
        return this.renderPayout();
    }
    getPaymentMethodLabel() {
        const { t } = this.props;
        const selectedValue = this.defineDropdownSelectedValue();
        const method = paymentMethods.find((m) => m.value === selectedValue);
        return method ? t(method.localizationSlug) : t('SELECT_PAYMENT_METHOD');
    }
    canMakePayment(payout) {
        return (payout.status === 'approved_internally' ||
            payout.status === 'payment_initialized');
    }
    allowPaymentSelection() {
        var _a;
        const { hasFinanceAdminRole, payout } = this.state;
        const status = payout === null || payout === void 0 ? void 0 : payout.status;
        const stripe_account_id = (_a = payout === null || payout === void 0 ? void 0 : payout.carrier) === null || _a === void 0 ? void 0 : _a.stripe_account_id;
        return (hasFinanceAdminRole &&
            stripe_account_id &&
            (status === paymentStatus.APPROVED_INTERNALLY ||
                status === paymentStatus.INTERNAL_REVIEW));
    }
    renderPayoutV1() {
        var _a, _b, _c;
        const { payout, isAdmin, confirmModal: { title, message, onConfirm }, } = this.state;
        const lineItemGroups = (_a = payout.lineItemGroups) !== null && _a !== void 0 ? _a : [];
        const { t } = this.props;
        const selectedValue = this.defineDropdownSelectedValue();
        const { status } = payout;
        const payoutStatusColor = getPayoutStatusColor(status);
        const pod_message = payout.missing_pods
            ? t('WITHOUT_PODS_JOBS')
            : t('ALL_PODS_RECEIVED');
        const podBadgeColor = payout.missing_pods
            ? 'border-red-200 bg-red-50 text-red-700'
            : 'border-emerald-200 bg-emerald-50 text-emerald-700';
        const BADGE_COLOR_MAP = {
            green: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            red: 'border-red-200 bg-red-50 text-red-700',
            blue: 'border-blue-200 bg-blue-50 text-blue-700',
            brand: 'border-emerald-200 bg-emerald-50 text-emerald-700',
            gray: 'border-gray-200 bg-gray-50 text-gray-700',
        };
        const showApprovalAction = status !== 'payment_initialized' &&
            status !== 'paid' &&
            status !== 'void';
        const approvalAction = status === 'approved_internally' ? 'Reverse Approval' : 'Approve';
        const showVoidAction = status !== 'approved_internally' &&
            status !== 'payment_initialized' &&
            status !== 'paid';
        const voidAction = status === 'void' ? 'Reverse Void' : 'Void';
        return (React.createElement("div", { "data-testid": "div-2dd250b7", className: "mx-auto max-w-7xl space-y-6 p-4 sm:p-6 lg:p-8" },
            React.createElement("div", { className: "flex flex-wrap items-start justify-between" },
                React.createElement("div", null,
                    React.createElement("div", { className: "flex items-center gap-3 flex-wrap" },
                        React.createElement("h2", { "data-testid": "h2-bede8f08", className: "my-0" }, payout.number),
                        payout.missing_pods != null && (React.createElement(Badge, { variant: "outline", "data-testid": "CargomaticBadge-1a4939eb", className: `gap-1 ${podBadgeColor}` }, pod_message)),
                        React.createElement(Badge, { variant: "outline", "data-testid": "CargomaticBadge-4b4cde3d", className: `gap-1 ${BADGE_COLOR_MAP[payoutStatusColor] || ''}` }, t(sluggify(payout.status)))),
                    payout.due_date && (React.createElement("span", { className: "text-sm text-muted-foreground" },
                        t('DUE_DATE'),
                        ": ",
                        moment(payout.due_date).format('L')))),
                React.createElement("div", { className: "flex items-center gap-3" }, isAdmin && (React.createElement(PaymentMethodDialog, { open: this.state.showPaymentMethodDialog, onOpenChange: (open) => {
                        this.setState(Object.assign({ showPaymentMethodDialog: open }, (open ? { tempPaymentMethod: selectedValue } : {})));
                    }, selectedValue: selectedValue, tempValue: this.state.tempPaymentMethod, onTempValueChange: (value) => this.setState({ tempPaymentMethod: value }), onSave: this.handleSavePaymentMethod, isSaving: this.state.isSavingPaymentMethod, disabled: !this.allowPaymentSelection(), label: this.getPaymentMethodLabel(), description: t('APPROVE_PAYOUTS_MSG_FOR_CARRIERS') })))),
            React.createElement("div", { className: "w-full lg:grid lg:grid-cols-3 lg:gap-4 lg:items-start" },
                React.createElement(Card, null,
                    React.createElement(CardHeader, null,
                        React.createElement("div", { className: "flex items-center justify-between" },
                            React.createElement("h3", { className: "my-0 text-base font-semibold" }, unescapeSpecialChars((_b = payout.carrier) === null || _b === void 0 ? void 0 : _b.name)),
                            React.createElement(Button, { variant: "outline", size: "sm", "data-testid": "button-d8ab3b86", disabled: payout.status !== 'internal_review' ||
                                    this.state.isReprocessing, onClick: this.reprocessCarrierPayout, className: "gap-1" },
                                React.createElement(RefreshCw, { className: "h-3.5 w-3.5" }),
                                t('REPROCESS_PAYOUT')))),
                    React.createElement(CardContent, { className: "space-y-4" },
                        React.createElement(PaymentSummary, { total: payout.total, paid: payout.total_payments, balance: payout.amount_due, currency: payout.currency }),
                        React.createElement("div", { className: "flex flex-wrap items-center gap-2" },
                            showApprovalAction && (React.createElement(Button, { variant: "outline", size: "sm", className: "gap-1", onClick: () => this.setState({ showApprovalModal: true }) },
                                React.createElement(CheckCircle, { className: "h-3.5 w-3.5" }),
                                t(sluggify(approvalAction)))),
                            showVoidAction && (React.createElement(Button, { variant: "outline", size: "sm", className: "gap-1 text-red-600", onClick: () => this.setState({ showVoidModal: true }) },
                                React.createElement(XCircle, { className: "h-3.5 w-3.5" }),
                                t(sluggify(voidAction)))),
                            React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                                React.createElement(Button, { variant: "outline", size: "sm", className: "gap-1", onClick: () => this.setState({ showSendEmailModal: true }) },
                                    React.createElement(Mail, { className: "h-3.5 w-3.5" }),
                                    titleize(t('EMAIL')))),
                            React.createElement(Button, { variant: "outline", size: "sm", className: "gap-1", onClick: this.handleDownload },
                                React.createElement(Download, { className: "h-3.5 w-3.5" }),
                                t('DOWNLOAD')),
                            React.createElement("a", { "data-testid": "a-566c3eb2", href: `/payouts/${payout._id}`, target: "_blank", rel: "noopener noreferrer", className: "inline-flex items-center gap-1 text-sm" },
                                React.createElement(ExternalLink, { className: "h-3.5 w-3.5" }),
                                t('OPEN_IN_NEW_TAB'))))),
                React.createElement(Card, null,
                    React.createElement(CardHeader, null,
                        React.createElement("div", { className: "flex items-center justify-between" },
                            React.createElement("h3", { className: "my-0 text-base font-semibold" }, t('PAYMENTS')),
                            this.canMakePayment(payout) && (React.createElement(Button, { size: "sm", className: "bg-zinc-900 text-white hover:bg-zinc-800 gap-2", "data-testid": "button-42a3d745", onClick: () => this.setState({ showLogPaymentModal: true }), disabled: this.state.balance === 0 },
                                React.createElement(DollarSign, { className: "h-4 w-4" }),
                                t('RECORD_PAYMENT'))))),
                    React.createElement(CardContent, null,
                        React.createElement(PaymentHistory, { payments: (_c = payout.payments) !== null && _c !== void 0 ? _c : [], currency: payout.currency }))),
                React.createElement(Card, { className: "max-h-96 flex flex-col overflow-hidden" },
                    React.createElement(CardHeader, null,
                        React.createElement("h3", { className: "my-0 text-base font-semibold" }, t('AUDIT_HISTORY'))),
                    React.createElement(CardContent, { className: "overflow-y-auto" },
                        React.createElement(HistoryTable, { data: payout.audit || [], type: "Payout" })))),
            React.createElement(Card, null,
                React.createElement(CardHeader, null,
                    React.createElement("div", { className: "flex items-center justify-between" },
                        React.createElement("div", { className: "flex items-center gap-3" },
                            React.createElement("h3", { className: "my-0 text-base font-semibold" }, t('JOBS')),
                            React.createElement("div", { className: "w-60" },
                                React.createElement(ShipmentSearch, { isFilter: true, lineItemGroups: lineItemGroups, onSelect: (value, job) => {
                                        this.handleSearch(payout, value, job);
                                    }, onChange: (value) => this.onSelectChange(value), disabled: !this.state.isFinanceAdmin }))))),
                React.createElement(CardContent, { className: "overflow-x-auto" },
                    React.createElement(PayoutJobList, { payout: payout }))),
            React.createElement(SendEmailModal, { show: this.state.showSendEmailModal, onSend: this.sendEmail, onHide: () => this.setState({ showSendEmailModal: false }) }),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-approval", show: this.state.showApprovalModal, title: t('VOID_MODAL_WITH_VALUE', {
                    action: t(sluggify(approvalAction)),
                    payoutID: payout.number,
                }), onConfirm: this.handleApprovalConfirm, onHide: () => this.setState({ showApprovalModal: false }), message: t('ARE_YOU_SURE'), hideButtonText: t('CANCEL'), affirmative: t('OK') }),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-void", show: this.state.showVoidModal, title: t('VOID_MODAL_WITH_VALUE', {
                    action: t(sluggify(voidAction)),
                    payoutID: payout.number,
                }), onConfirm: this.handleVoidConfirm, onHide: () => this.setState({ showVoidModal: false }), message: t('ARE_YOU_SURE'), hideButtonText: t('CANCEL'), affirmative: t('OK'), primaryButtonColor: "red" }),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-af080161", show: this.state.showLineItemConfirmModal, title: title, message: message, onConfirm: onConfirm, onHide: () => this.setState({ showLineItemConfirmModal: false }) }),
            this.state.showLogPaymentModal && (React.createElement(LogPaymentModal, { show: this.state.showLogPaymentModal, amount: (this.state.balance || 0).toFixed(2), onSave: this.savePayment, onHide: () => this.setState({ showLogPaymentModal: false }) }))));
    }
    renderPayoutV2() {
        var _a, _b;
        const { payout, isAdmin, confirmModal: { title, message, onConfirm }, } = this.state;
        const lineItemGroups = (_a = payout.lineItemGroups) !== null && _a !== void 0 ? _a : [];
        const { t } = this.props;
        const selectedValue = this.defineDropdownSelectedValue();
        return (React.createElement("div", { "data-testid": "div-2dd250b7", className: "mx-auto max-w-7xl space-y-6 p-4 sm:p-6 lg:p-8" },
            React.createElement(PayoutHeader, { payout: payout, isModal: !!this.props.payoutId, onPayoutUpdated: this.handlePayoutUpdated }),
            React.createElement(Card, null,
                React.createElement(Tabs, { defaultValue: "jobs", className: "w-full", onValueChange: (value) => this.setState({ activeTab: value }) },
                    React.createElement(CardHeader, { className: "pb-3" },
                        React.createElement(TabsList, { className: "justify-start" },
                            React.createElement(TabsTrigger, { value: "jobs" }, t('LINE_ITEMS')),
                            React.createElement(TabsTrigger, { value: "payments" }, t('PAYMENTS')),
                            React.createElement(TabsTrigger, { value: "audit" }, t('AUDIT_HISTORY')))),
                    React.createElement(TabsContent, { value: "jobs", className: "mt-0 space-y-4" },
                        React.createElement("div", { className: "px-6" },
                            React.createElement("div", { className: "w-full sm:w-80" },
                                React.createElement(ShipmentSearch, { isFilter: true, lineItemGroups: lineItemGroups, onSelect: (value, job) => {
                                        this.handleSearch(payout, value, job);
                                    }, onChange: (value) => this.onSelectChange(value), disabled: !this.state.isFinanceAdmin }))),
                        React.createElement(CardContent, { className: "overflow-x-auto" },
                            React.createElement(PayoutJobList, { payout: payout }))),
                    React.createElement(TabsContent, { value: "payments", className: "mt-0" },
                        React.createElement(CardContent, { className: "space-y-4" },
                            React.createElement("div", { className: "flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between" },
                                React.createElement("h3", { className: "text-base font-semibold my-0" }, "Payment History"),
                                React.createElement("div", { className: "flex flex-wrap items-center gap-3" },
                                    isAdmin && (React.createElement(PaymentMethodDialog, { open: this.state.showPaymentMethodDialog, onOpenChange: (open) => {
                                            this.setState(Object.assign({ showPaymentMethodDialog: open }, (open
                                                ? { tempPaymentMethod: selectedValue }
                                                : {})));
                                        }, selectedValue: selectedValue, tempValue: this.state.tempPaymentMethod, onTempValueChange: (value) => this.setState({ tempPaymentMethod: value }), onSave: this.handleSavePaymentMethod, isSaving: this.state.isSavingPaymentMethod, disabled: !this.allowPaymentSelection(), label: this.getPaymentMethodLabel(), description: t('APPROVE_PAYOUTS_MSG_FOR_CARRIERS') })),
                                    this.canMakePayment(payout) && (React.createElement(Button, { size: "sm", className: "bg-zinc-900 text-white hover:bg-zinc-800 gap-2", "data-testid": "button-42a3d745", onClick: () => this.setState({ showLogPaymentModal: true }), disabled: this.state.balance === 0 },
                                        React.createElement(DollarSign, { className: "h-4 w-4" }),
                                        t('RECORD_PAYMENT'))))),
                            React.createElement(PaymentHistory, { payments: (_b = payout.payments) !== null && _b !== void 0 ? _b : [], currency: payout.currency }))),
                    React.createElement(TabsContent, { value: "audit", className: "mt-0" },
                        React.createElement(CardContent, null,
                            React.createElement(HistoryTable, { data: payout.audit || [], type: "Payout" }))))),
            React.createElement(ConfirmModal, { dataTestId: "ConfirmModal-af080161", show: this.state.showLineItemConfirmModal, title: title, message: message, onConfirm: onConfirm, onHide: () => this.setState({ showLineItemConfirmModal: false }) }),
            this.state.showLogPaymentModal && (React.createElement(LogPaymentModal, { show: this.state.showLogPaymentModal, amount: (this.state.balance || 0).toFixed(2), onSave: this.savePayment, onHide: () => this.setState({ showLogPaymentModal: false }) }))));
    }
    renderPayout() {
        const order = this.state.order;
        if (isLegManagementEnabled(order)) {
            return this.renderPayoutV2();
        }
        return this.renderPayoutV1();
    }
}
PayoutDetails.propTypes = {
    match: PropTypes.object,
};
export default withTranslation()(PayoutDetails);
